const USER_URL = process.env.USER_ENDPOINT

export default {
  computed: {
    userEndPoint: () => USER_URL,
    userImageUrl: () => `${USER_URL}/image?id=`,
    entryFormTypeMap () {
      return {
        simple: 'SIMPLE', // シンプル応募（自己PR不要）
        light: 'LIGHT' // ライト応募（自己PRと職歴不要）
      }
    },
    isSimpleTypeEntryFrom () {
      return this.entryFormType === this.entryFormTypeMap.simple
    },
    isLightTypeEntryForm () {
      return this.entryFormType === this.entryFormTypeMap.light
    },
    showAttentionPoint1 () {
      return this.jobInfo.attentionPointCaption1.value && this.jobInfo.attentionPointBody1.value
    },
    showAttentionPoint2 () {
      return this.jobInfo.attentionPointCaption2.value && this.jobInfo.attentionPointBody2.value
    },
    showTimeSchedule () {
      return this.jobInfo.timeScheduleTitle.value && !!this.jobInfo.timeSchedules.length
    },
    placeText () {
      return this.places.map(placeInfo => {
        if (placeInfo.areas.length !== 0) {
          return `<b>${placeInfo.place}</b>(${placeInfo.areas.join('、')})`
        } else {
          return `<b>${placeInfo.place}</b>`
        }
      }).join('、')
    },
    showPassChild () {
      return this.jobInfo.careerPath.value || this.jobInfo.supportAfterJoin.value
    },
    showSuitablePerson () {
      return this.jobInfo.suitableForThisJob.value && this.jobInfo.notSuitableForThisJob.value
    },
    employmentStatusText () {
      return this.jobInfo.employmentStatus.length ? this.jobInfo.employmentStatus.join('/') : ''
    },
    togglePlacesText () {
      return this.isOpenPlaces ? '勤務地を閉じる ∧' : '勤務地をさらに表示 ∨'
    },
    containsAnyOfficeReports () {
      return this.companyInterview.interviewBody.value ||
      this.companyInterview.topicsTitle1.value ||
      this.companyInterview.topicsTitle2.value ||
      this.showPhotoArea
    },
    showFreeArticle () {
      return this.companyInterview.topicsTitle1.value || this.companyInterview.topicsTitle2.value
    },
    freeArticleTitle () {
      return this.jobInfo.isCompanyStaffInterview ? '社員インタビュー' : 'トピックス'
    },
    showPhotoArea () {
      return this.showPhoto1 || this.showPhoto2 || this.showPhoto3
    },
    showPhoto1 () {
      return this.companyInterview.sugaoPhoto1 && this.companyInterview.sugaoPhotoCaption1.value
    },
    showPhoto2 () {
      return this.companyInterview.sugaoPhoto2 && this.companyInterview.sugaoPhotoCaption2.value
    },
    showPhoto3 () {
      return this.companyInterview.sugaoPhoto3 && this.companyInterview.sugaoPhotoCaption3.value
    },
    containsAnyEmployeeDetails () {
      return this.companyInfo.employeesNum.value ||
      this.companyInfo.averageAge.value ||
      this.companyInfo.employeesSexRatio.value ||
      this.companyInfo.middleEnterRatio.value
    }
  }
}
